import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';

import { PREVENTIVE_TASK_EXECUTION_ENDPOINT } from '../../config/endpoints';

import {
  BASIC_POST_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
} from '../../config/rest';

import { isErrorResponse } from '../../utils/error-handlers';
import { PREVENTIVE_TASK_EXECUTION_PATH } from '../../config/paths';

import {
  CLEAR_PREVENTIVE_TASK_EXECUTION,
  CLEAR_PREVENTIVE_TASK_EXECUTIONS,
  FLAG_GETTING_PREVENTIVE_TASK_EXECUTIONS,
  FLAG_PREVENTIVE_TASK_EXECUTION_ACTIVITY,
  GET_PREVENTIVE_TASK_EXECUTION,
  GET_PREVENTIVE_TASK_EXECUTIONS,
} from '../types/task-schedule';

const flagGettingPreventiveTaskExecutions = (payload) => ({
  type: FLAG_GETTING_PREVENTIVE_TASK_EXECUTIONS,
  payload,
});

const flagPreventiveTaskExecutionActivity = (payload) => ({
  type: FLAG_PREVENTIVE_TASK_EXECUTION_ACTIVITY,
  payload,
});

const postPreventiveTaskExecutions = (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingPreventiveTaskExecutions(true));

    const { page = 0, size = 1000, sort, ...bodyFilters } = tableFilters || {};

    const params = new URLSearchParams();

    params.append('page', page);
    params.append('size', size);

    if (sort) {
      if (Array.isArray(sort)) {
        sort.forEach((sortValue) => params.append('sort', sortValue));
      } else {
        params.append('sort', sort);
      }
    }

    const response = await fetch(
      `${PREVENTIVE_TASK_EXECUTION_ENDPOINT}-history-report?${params.toString()}`,
      {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(bodyFilters),
      },
    );

    await isErrorResponse(response, null, dispatch);

    const preventiveTaskExecutions = await response.json();

    dispatch({
      type: GET_PREVENTIVE_TASK_EXECUTIONS,
      payload: preventiveTaskExecutions,
    });

    return preventiveTaskExecutions;
  } catch ({ message }) {
    toastr.error('Error', message);
    throw new Error(message);
  } finally {
    dispatch(flagGettingPreventiveTaskExecutions(false));
  }
};
const getPreventiveTaskExecution =
  ({ preventiveTaskExecutionId }) =>
  async (dispatch) => {
    try {
      dispatch(flagPreventiveTaskExecutionActivity(true));

      const url = `${PREVENTIVE_TASK_EXECUTION_ENDPOINT}/${preventiveTaskExecutionId}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      const preventiveTaskExecution = await response.json();

      dispatch({
        type: GET_PREVENTIVE_TASK_EXECUTION,
        payload: preventiveTaskExecution,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagPreventiveTaskExecutionActivity(false));
    }
  };

const postPreventiveTaskExecution =
  (preventiveTaskExecution, options = {}) =>
  async (dispatch) => {
    const { redirect = true } = options;

    try {
      dispatch(flagPreventiveTaskExecutionActivity(true));

      const formData = new FormData();

      const { attachedFile, ...data } = preventiveTaskExecution;

      formData.append(
        'data',
        new Blob([JSON.stringify(data)], {
          type: 'application/json',
        }),
      );

      if (attachedFile) {
        formData.append('file', attachedFile);
      }

      const response = await fetch(PREVENTIVE_TASK_EXECUTION_ENDPOINT, {
        ...BASIC_POST_CONFIG,
        body: formData,
      });

      await isErrorResponse(response, null, dispatch);

      const savedPreventiveTaskExecution = await response.json();

      toastr.success('Éxito', 'Ejecución registrada correctamente');

      if (redirect) {
        dispatch(
          push(
            `${PREVENTIVE_TASK_EXECUTION_PATH}/${savedPreventiveTaskExecution.id}`,
          ),
        );
      }

      return savedPreventiveTaskExecution;
    } catch ({ message }) {
      toastr.error('Error', message);
      return null;
    } finally {
      dispatch(flagPreventiveTaskExecutionActivity(false));
    }
  };

const clearPreventiveTaskExecutions = () => ({
  type: CLEAR_PREVENTIVE_TASK_EXECUTIONS,
});

const clearPreventiveTaskExecution = () => ({
  type: CLEAR_PREVENTIVE_TASK_EXECUTION,
});

export {
  postPreventiveTaskExecutions,
  getPreventiveTaskExecution,
  postPreventiveTaskExecution,
  clearPreventiveTaskExecutions,
  clearPreventiveTaskExecution,
};
